import { Box, Typography, Link as MUILink, Stack } from "@mui/material";
import DatalignChip from "datalign-module-template/components/datalign-chip";
import { useEasierTheme } from "datalign-themes";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const TagsField = ({
  tags,
  isSearchCard = false,
  geospatial = false,
  tagType = "tags",
}: {
  tags: string[] | undefined;
  isSearchCard?: boolean;
  geospatial?: boolean;
  tagType?: string;
}) => {
  const theme = useEasierTheme();

  const tagStyles = {
    color: "inherit",
    fontFamily: "proxima, sans-serif",
    fontSize: "1rem",
    fontWeight: 475,
    lineHeight: 1.5,
    maxWidth: "100%",
    overflowWrap: "break-word",
    textAlign: "center",
    textDecoration: "none", // remove default link underline
  };

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      sx={{
        maxWidth: "100%", // Prevent overflow
        overflow: "hidden", // Hide overflow just in case
      }}
    >
      {tags &&
        tags.length > 0 &&
        tags.map((tag) => (
          <Box
            key={`tag-${tag}`}
            sx={{
              mr: 1,
              mb: 1,
              maxWidth: "100%", // Chip box can't go wider than container
              minWidth: 40, // Allow shrinking properly
            }}
          >
            <DatalignChip
              key={`tag-${tag}`}
              filled={
                !["FAF-nt", "nrdata-orig"].includes(
                  process.env.REACT_APP_STYLING_THEME ?? "",
                )
              }
              chipColour={
                ["FAF-nt", "nrdata-orig"].includes(
                  process.env.REACT_APP_STYLING_THEME ?? "",
                )
                  ? isSearchCard
                    ? theme?.Colour.Primary()
                    : "#E35205"
                  : undefined
              }
              textColour={
                ["FAF-nt", "nrdata-orig"].includes(
                  process.env.REACT_APP_STYLING_THEME ?? "",
                )
                  ? isSearchCard
                    ? theme?.Colour.Primary()
                    : "#E35205"
                  : undefined
              }
              content={
                geospatial ? (
                  <Typography sx={tagStyles}>{tag}</Typography>
                ) : (
                  <MUILink
                    sx={tagStyles}
                    to={`/search?${tagType}=${tag}`}
                    component={RouterLink}
                    underline="hover"
                  >
                    {tag}
                  </MUILink>
                )
              }
            />
          </Box>
        ))}
    </Box>
  );
};

export default TagsField;
